import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { deleteBulkWaJobUserData, deleteDuplicatePhonesBulkWhatSAppJobUserData, deleteInvalidPhonesBulkWhatSAppJobUserData, deleteSingleUserFromBulkWhatsAppUserData, getWaJobById, getWaJobUserDataById, sendBulk, updateWaJobById, updateWhatsappMsgDeliveryStatus, whatsappConfiguration } from "../../../Http/Index";
import { EmailJobsInterface, JobStatus, QueryStatus } from "../WhatsAppBulkMessage";
import { Box, Button, Flex, Input, Select, Table, Tbody, Td, Text, Th, Thead, Tr, useToast } from "@chakra-ui/react";
import { Layout } from "../../../GlobalComponent/Layout/Layout";
import { BenFilterPopup } from "../../../GlobalComponent/BenFIlterPopup/BenFilterPoup";
import { handleCloseModal } from "../../BenAddressData/Action/actions";
import { MdDelete } from "react-icons/md";

interface BulkEmailTemplate {
    _id: string;
    templateId: string; // The identifier (e.g., "NOTIFY_EC_ON_AMBULANCE_BOOKING")
    TEMPLATE: string;
    TEMPLATE_LANGUAGE_CODE: string;
    TEMPLATE_VARS?: string[];
    TEMPLATE_HEADER_TYPE?: 'IMAGE' | 'DOCUMENT' | 'VIDEO' | ''; // Optional, based on usage
    TEMPLATE_HEADER_URL?: string;
    TEMPLATE_CATEGORY?: 'bulk' | ''; // Optional, based on usage
    BUTTON_VARS?: string[];
    isDynamic:Boolean
}

export enum EmailStatus {
    Pending = 'Pending',
    Sent = 'Sent',
    Error = 'Error'
}
export interface BulkWhatsAppJobUserData {
    _id: string;
    jobId: EmailStatus;
    benId: string;
    benName: string;
    phoneNumber: string;
    status: string;
    deliveryStatus: string;
    reason: string;
    whatsappMsgId: string,
    dynamicValues: {
        [key: string]: any; // In case there are more dynamic keys
    };
}

export const SingleWhatsAppJob: React.FC = () => {
    const { jobId: emailJobId } = useParams()
    const [jobUserData, setJobUserData] = useState<{
        jobData: BulkWhatsAppJobUserData[],
        hasNextPage: boolean,
        hasPreviousPage: boolean,
        totalPages: number,
        page: number,
        limit: number,
        totalCount: number,
        totalSuccessCount: number,
        totalFailedCount: number,
        totalInvalidPhoneNumbers: number,
        deliveryFailedCount: number,
        deliverySuccessCount: number
    }>()
    const [job, setJob] = useState<EmailJobsInterface>()
    const [bulkTemplates, setBulkTemplates] = useState<BulkEmailTemplate[] | []>([])
    const [selectedTemplate, setSelectedTemplate] = useState<BulkEmailTemplate>()
    const navigate = useNavigate()
    const [benFilter, setBenFilter] = useState<boolean>(false);
    const [inputVariables, setInputVariables] = useState<any>({})
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const toast = useToast()
    // const [messageTo, setMessageTo] = useState<string>("All")
    const [isEditVars, setIsEditVars] = useState<boolean>(false)
    const [isPaginationLoading, setIsPaginationLoading] = useState<boolean>(false)
    const [pageLimit, setPageLimit] = useState<number>(10)



    useEffect(() => {
        (async () => { getSingleJob() })();
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (job?.jobStatus === JobStatus.Completed) {
            getBulkTemplates()
        }
        // eslint-disable-next-line
    }, [jobUserData])

    useEffect(() => {
        if (job?.jobStatus === JobStatus.Completed) {
            let template = bulkTemplates.find((item) => item.templateId === job?.templateId)
            setSelectedTemplate(template)
        }
        // eslint-disable-next-line
    }, [bulkTemplates])

    const getSingleJob = async () => {
        try {
            if (emailJobId) {
                let response = (await getWaJobById(emailJobId)).data
                const bulkJobUserData = await getWaJobUserDataById(emailJobId, 1, pageLimit)
                setJob(response.data)
                setJobUserData(bulkJobUserData.data)
                if (response.data.templateId) {
                    const temp = await whatsappConfiguration()
                    const filteredTemp = temp.data.find((item: any) => item.templateId === response.data.templateId)
                    setSelectedTemplate(filteredTemp)
                    setBulkTemplates(temp.data)
                    const existingInput = response.data?.customInput || {}
                    setInputVariables(filteredTemp?.TEMPLATE_HEADER_URL ? { ...existingInput, url: existingInput.url || filteredTemp.TEMPLATE_HEADER_URL } : existingInput)
                }
            } else {
                alert("Invalid JobId")
                navigate("/bulk_wa_message")
            }

        } catch (error: any) {
            console.log(error)
            if (error?.response?.data?.statusCode === 404 || 400) {
                alert("Invalid JobId")
            } else {
                alert(error?.response?.data?.message)
            }
            navigate("/bulk_wa_message")
        }
    }

    const getBulkTemplates = async () => {
        if (bulkTemplates?.length <= 0) {
            try {
                let response = await whatsappConfiguration()
                setBulkTemplates(response.data)
            } catch (error) {
                console.log(error)
                alert("Error while getting Templates")
            }
        } else {
            return
        }
    }

    const handleTemplateInput = (e: React.ChangeEvent<HTMLSelectElement>) => {
        let temp = bulkTemplates.filter((item) => item.templateId === e.target.value)
        setSelectedTemplate(temp[0])
        setInputVariables((prev: any) => ({ ...prev, url: temp[0]?.TEMPLATE_HEADER_URL || "" }))
    }

    // const handleMessageToInput = (e: React.ChangeEvent<HTMLSelectElement>) => {
    //     setMessageTo(e.target.value)
    // }

    const handleFilterModal = () => {
        setBenFilter(!benFilter);
    };

    const deleteJobBen = async (benId: string) => {
        try {
            setIsLoading(true)
            await deleteSingleUserFromBulkWhatsAppUserData(emailJobId!, benId)
        } catch (error: any) {
            alert(error?.response?.data?.message)
        } finally {
            handlePagination(jobUserData?.page || 1, pageLimit)
            setIsLoading(false)
        }
    }

    const sendEmail = async (e: React.MouseEvent<HTMLButtonElement>) => {
        setIsLoading(true)
        // const emailTo = (e.currentTarget as HTMLButtonElement).value;
        try {
            if (job?.templateId && emailJobId && selectedTemplate) {
                const temp = bulkTemplates.find((item) => item.templateId === job.templateId)
                if (!temp) {
                    alert("Template not saved")
                    return
                }

                if (!jobUserData || jobUserData.totalCount <= 0) {
                    alert("No Job user data present")
                    return
                }

                if (temp.TEMPLATE_VARS?.length && temp?.TEMPLATE_VARS?.includes("customField")) {
                    if (!job.customInput || !job.customInput["customField"]) {
                        alert("Please Provide Custom Field")
                        return
                    }
                }

                if (temp.TEMPLATE_HEADER_TYPE) {
                    if (!job.customInput || !job.customInput["url"]) {
                        alert("Please Provide Headers URL")
                        return
                    }
                }

                if (jobUserData?.totalInvalidPhoneNumbers) {
                    alert("Please clear invalid phone numbers")
                    return
                }

                await sendBulk({ jobId: emailJobId! })
                toast({
                    title: 'Sending Messages Is In Progress',
                    description: "Please refresh the page after some time if loading takes time",
                    status: 'success',
                    duration: 9000,
                    isClosable: true,
                    position: "top"
                })
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            } else {
                alert("Please Select Template")
            }
            setIsLoading(false)
        } catch (error: any) {
            alert(error?.response?.data?.message)
            setIsLoading(false)
            toast({
                title: 'Request Failed',
                description: "Please try again.",
                status: 'error',
                duration: 9000,
                isClosable: true,
                position: "top"
            })
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        } finally {
            setIsLoading(false)
        }

    }


    const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputVariables((prev: object) => { return { ...prev, [e.target.name]: e.target.value } })
    }

    const deleteAllBenFromJob = async () => {
        setIsLoading(true)
        try {
            await deleteBulkWaJobUserData(emailJobId!)
        } catch (error: any) {
            alert(error?.response?.data?.message)
        }
        finally {
            handlePagination(1, pageLimit)
            setIsLoading(false)
        }
    }

    const saveBasicJobData = async () => {
        try {
            setIsLoading(true)
            if (!selectedTemplate) {
                alert("Please select a template")
                return
            }

            if (selectedTemplate.TEMPLATE_VARS?.length && selectedTemplate?.TEMPLATE_VARS?.includes("customField") && !inputVariables["customField"]) {
                alert("Please Provide Custom Field")
                return
            }
            if (selectedTemplate.TEMPLATE_HEADER_TYPE && !inputVariables["url"]) {
                alert("Please Provide Headers URL")
                return
            }

            let response = await updateWaJobById(emailJobId!, { templateName: selectedTemplate?.templateId, templateId: selectedTemplate?.templateId, customInput: inputVariables, jobStatus: JobStatus.Pending })
            setJob(response.data?.data)
            setIsEditVars(false)
            window.location.reload()
        } catch (error: any) {
            alert(error?.response?.data?.message)
            window.location.reload()
        } finally {
            setIsLoading(false)
        }
    }

    const handlePagination = async (page: number, limit: number) => {
        try {
            setIsPaginationLoading(true)
            const response = await getWaJobUserDataById(emailJobId!, page, limit)
            setJobUserData(response.data)
        } catch (error: any) {
            alert(error?.response?.data?.message)
        }
        finally {
            setIsPaginationLoading(false)
        }
    }

    const handlePageLimit = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setPageLimit(Number(e.target.value))
        handlePagination(1, Number(e.target.value))
    }

    const isValidPhoneNumber = (phone: string): boolean => {
        const phoneRegex = /^[6-9]\d{9}$/;
        return phoneRegex.test(phone);
    };

    const isDuplicatePhone = (phone: string, currentIndex: number): boolean => {
        if (!jobUserData?.jobData) return false;
        return jobUserData.jobData.some((item, index) => 
            index !== currentIndex && item.phoneNumber === phone
        );
    };

   

    const clearInvalidEmailBens = async () => {
        try {
            setIsLoading(true)
            await deleteInvalidPhonesBulkWhatSAppJobUserData(emailJobId!)
            alert("Deleted Invalid Phones")
        } catch (error: any) {
            alert(error?.response?.data?.message)
        } finally {
            handlePagination(1, pageLimit)
            setIsLoading(false)
        }
    }

    const handleDiscard = () => {
        setIsEditVars(!isEditVars)
        if (isEditVars) {
            window.location.reload()
        }
    }

    const fetchDeliveryStatus = async () => {
        try {
            if (emailJobId) {
                setIsLoading(true);
                let response = await (await updateWhatsappMsgDeliveryStatus(emailJobId)).data
                alert(response.message)
            }
        } catch (err) {
            alert(err)
        } finally {
            setIsLoading(false)
            window.location.reload()
        }
    }

    const clearDuplicatePhone=async()=>{
        try{
            setIsLoading(true)
            if (job?._id) {
                await deleteDuplicatePhonesBulkWhatSAppJobUserData(job._id)
                alert("Duplicate phone numbers cleared successfully")
            }
        }catch(err: any){
            alert(err?.response?.data?.message || "Error clearing duplicates")
        } finally {
            handlePagination(1, pageLimit)
            setIsLoading(false)
        }
    }
    return (
        <Layout>
            <Box width={"95%"} margin={"auto"} paddingBottom={"30px"}>
                <Flex width={"fit-content"} padding={"10px"} borderRadius={"10px"} gap={"20px"}>
                    <Text fontWeight={"bold"}>Job_Name: {job?.jobName || "N/A"}</Text>
                    <Text color={"blue"} fontWeight={"bold"}>Total_Count: {jobUserData?.totalCount}</Text>
                    <Text color={"green"} fontWeight={"bold"}>Sent_From_Our_End: {jobUserData?.totalSuccessCount}</Text>
                    <Text color={jobUserData && jobUserData.totalFailedCount > 0 ? "red" : "green"} fontWeight={"bold"}>Failed_From_Our_End: {jobUserData?.totalFailedCount}</Text>
                    <Text color={jobUserData && jobUserData?.totalInvalidPhoneNumbers > 0 ? "red" : "green"} fontWeight={"bold"}>Invalid_Phone_Numbers: {jobUserData?.totalInvalidPhoneNumbers}</Text>
                    <Text fontWeight={"bold"} color={((jobUserData?.totalCount || 0) - ((jobUserData?.totalSuccessCount || 0) + (jobUserData?.totalFailedCount || 0))) > 0 ? "orange" : "green"}>Pending_From_Our_End: {(jobUserData?.totalCount || 0) - ((jobUserData?.totalSuccessCount || 0) + (jobUserData?.totalFailedCount || 0))}</Text>
                    {job?.jobStatus === JobStatus.Completed && <Text color={jobUserData && jobUserData?.deliverySuccessCount > 0 ? "green" : "red"} fontWeight={"bold"}>Delivered: {jobUserData?.deliverySuccessCount}</Text>}
                    {job?.jobStatus === JobStatus.Completed && <Text color={jobUserData && jobUserData?.deliveryFailedCount > 0 ? "red" : "green"} fontWeight={"bold"}>Delivery_Failed: {jobUserData?.deliveryFailedCount}</Text>}
                </Flex>
                <Flex gap={"20px"} mt={"30px"} justifyContent={"center"} alignItems={"center"}>

                    {job?.jobStatus !== "Completed" && <Select value={selectedTemplate?.templateId} placeholder="Select Template" onClick={getBulkTemplates} width={"fit-content"} onChange={handleTemplateInput} isDisabled={(!isEditVars)} >
                        {bulkTemplates?.length > 0 && bulkTemplates.map((item) =>
                            <option value={item.templateId} key={item._id}> {item.templateId}</option>
                        )}
                    </Select>}
                    {job?.jobStatus === "Completed" && selectedTemplate && <Select width={"fit-content"} onChange={handleTemplateInput} isDisabled={job?.jobStatus === "Completed"}>
                        <option value={selectedTemplate.templateId} key={selectedTemplate._id}> {selectedTemplate.templateId}</option>
                    </Select>}

                    {selectedTemplate?.TEMPLATE_VARS?.includes("customField") &&
                        < Box  >
                            <label >Custom Field: </label>
                            <Input
                                isDisabled={!isEditVars}
                                onChange={handleInput}
                                width={"fit-content"}
                                type="text"
                                name={"customField"}
                                value={inputVariables["customField"]}
                                placeholder="Custom Field"></Input>
                        </Box>}

                    {selectedTemplate?.TEMPLATE_HEADER_TYPE && <Box style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <label>Headers URL: </label>
                        <Input
                            isDisabled={!isEditVars || !!selectedTemplate?.TEMPLATE_HEADER_URL}
                            onChange={handleInput}
                            width="fit-content"
                            type="text"
                            name="url"
                            value={inputVariables["url"]}
                            placeholder="URL"
                        />
                        {inputVariables["url"] && (
                            <Button colorScheme="blue" size="sm" onClick={() => window.open(inputVariables["url"], "_blank")}>Preview</Button>
                        )}
                    </Box>
                    }

                    <Button colorScheme="green" padding={"20px"} onClick={saveBasicJobData} isDisabled={(job?.jobStatus === JobStatus.Completed || isLoading || (jobUserData && jobUserData?.jobData?.length > 0)) || (!isEditVars)} >Save</Button>
                    <Button colorScheme="green" padding={"20px"} onClick={handleDiscard} isDisabled={(job?.jobStatus === JobStatus.Completed) || isLoading || (jobUserData && jobUserData?.jobData?.length > 0)}>{isEditVars ? "Discard" : "Edit"}</Button>
                </Flex>
                {job?.jobStatus !== JobStatus.Completed && <Flex gap={"20px"} mt={"30px"} justifyContent={"center"} alignItems={"center"}>
                    <Button colorScheme="green" value={"All"} isLoading={(job?.jobStatus === JobStatus.Inprogress)} onClick={sendEmail} isDisabled={isLoading || !selectedTemplate || (jobUserData && !jobUserData?.jobData?.length) || (job?.filterQuery.some((item) => item.status === QueryStatus.Inprogress))}>Send</Button>
                    <Button colorScheme="green" isLoading={job?.filterQuery.some((item) => item.status === QueryStatus.Inprogress)} onClick={handleFilterModal} isDisabled={isLoading || !job?.templateId || job?.jobStatus === JobStatus.Inprogress || (job.templateId && (job.templateId !== selectedTemplate?.templateId)) ? true : false}>Add Beneficiary</Button>
                    <Button colorScheme="green" onClick={deleteAllBenFromJob} isDisabled={isLoading || job?.jobStatus === JobStatus.Inprogress || !job?.templateId || (job?.filterQuery.some((item) => item.status === QueryStatus.Inprogress))}>Clear Job Data</Button>
                    <Button colorScheme="green" onClick={clearInvalidEmailBens} isDisabled={(jobUserData && jobUserData?.jobData?.length <= 0) || isLoading || job?.jobStatus === JobStatus.Inprogress || (job?.filterQuery.some((item) => item.status === QueryStatus.Inprogress))}>Clear Invalid Phones</Button>
                    <Button colorScheme="green" onClick={clearDuplicatePhone} isDisabled={selectedTemplate?.isDynamic !== false || (jobUserData && jobUserData?.jobData?.length <= 0) || isLoading || job?.jobStatus === JobStatus.Inprogress || (job?.filterQuery.some((item) => item.status === QueryStatus.Inprogress)) }>Clear Duplicate Number</Button>
                </Flex>}

                <Flex
                    display={jobUserData?.jobData && jobUserData?.jobData?.length > 0 ? "flex" : "none"}
                    justifyContent={"center"}
                    gap={"20px"}
                    alignItems={"center"}
                    mt={"30px"}
                    padding={"10px"}
                >
                    <Button colorScheme="green" isLoading={(job?.jobStatus === JobStatus.Inprogress)} onClick={sendEmail} display={(jobUserData?.totalFailedCount !== 0 || jobUserData.deliveryFailedCount) ? "block" : "none"} isDisabled={isLoading}>Resend Failed</Button>
                    <Button colorScheme="green" display={job?.jobStatus === JobStatus.Completed ? "block" : "none"} isLoading={job?.isDeliveryStatusApiLoading} onClick={fetchDeliveryStatus}>
                        Fetch Delivery Status
                    </Button>
                    {/* Previous Button */}
                    <Button
                        isLoading={isPaginationLoading}
                        onClick={() =>
                            handlePagination(
                                jobUserData?.page ? Number(jobUserData.page) - 1 : 1,
                                jobUserData?.limit ? Number(jobUserData.limit) : 10
                            )
                        }
                        colorScheme="green"
                        isDisabled={!jobUserData?.hasPreviousPage}
                    >
                        Previous
                    </Button>

                    {/* Page Dropdown */}
                    <Select
                        width={"fit-content"}
                        value={jobUserData?.page}
                        onChange={(e) =>
                            handlePagination(
                                Number(e.target.value),
                                jobUserData?.limit ? Number(jobUserData.limit) : 10
                            )
                        }
                        isDisabled={isPaginationLoading}
                    >
                        {Array.from({ length: jobUserData?.totalPages || 0 }, (_, index) => (
                            <option key={index + 1} value={index + 1}>
                                Page {index + 1} of {jobUserData?.totalPages}
                            </option>
                        ))}
                    </Select>

                    {/* Next Button */}
                    <Button
                        isLoading={isPaginationLoading}
                        colorScheme="green"
                        onClick={() =>
                            handlePagination(
                                jobUserData?.page ? Number(jobUserData.page) + 1 : 1,
                                jobUserData?.limit ? Number(jobUserData.limit) : 10
                            )
                        }
                        isDisabled={!jobUserData?.hasNextPage}
                    >
                        Next
                    </Button>

                    {/* Limit Dropdown */}
                    <Select
                        width={"fit-content"}
                        onChange={handlePageLimit}
                        isDisabled={isPaginationLoading}
                        value={jobUserData?.limit}
                    >
                        <option value={10}>10</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={200}>200</option>
                        <option value={300}>300</option>
                    </Select>
                </Flex>
                <Table variant="unstyled" mt={"30px"}>
                    <Thead>
                        <Tr>
                            <Th>SR.NO</Th>
                            <Th>BENEFICIARY NAME</Th>
                            <Th>BENEFICIARY PHONE</Th>
                            <Th>BENEFICIARY ID</Th>
                            <Th>STATUS</Th>
                            {job?.jobStatus === JobStatus.Completed && <Th>Delivery Status</Th>}
                            {job?.jobStatus !== JobStatus.Completed && <Th>Remove</Th>}
                            {job?.jobStatus === JobStatus.Completed && <Th>Remark</Th>}
                            {job?.jobStatus === JobStatus.Completed && <Th>WhatsApp Id</Th>}
                            {!!(selectedTemplate?.TEMPLATE_HEADER_TYPE || selectedTemplate?.TEMPLATE_VARS?.length || selectedTemplate?.BUTTON_VARS?.length) && (
                                <Th>Dynamic Data</Th>
                            )}

                        </Tr>
                    </Thead>
                    <Tbody >
                        {jobUserData &&
                            jobUserData?.jobData.map((item, index) => {
                                return (
                                    <Tr key={item.benId} >
                                        <Td>{((jobUserData.limit) * ((jobUserData.page) - 1)) + index + 1}</Td>
                                        <Td>{item.benName}</Td>
                                        <Td backgroundColor={
                                            !isValidPhoneNumber(item.phoneNumber) ? "red.100" :
                                            isDuplicatePhone(item.phoneNumber, index) ? "orange.100" : "white"
                                        }>{item.phoneNumber}</Td>
                                        <Td>{item.benId}</Td>
                                        <Td>{item.status}</Td>
                                        {job?.jobStatus === JobStatus.Completed && <Td>{(item.deliveryStatus) || (item.status === "Sent" ? "Not Updated" : "N/A")}</Td>}
                                        {job?.jobStatus !== JobStatus.Completed && <Td>
                                            <Flex justifyContent={"center"} >
                                                <Button onClick={() => deleteJobBen(item.benId)} isDisabled={isLoading || (job?.jobStatus === JobStatus.Inprogress)} >
                                                    <MdDelete color="red" ></MdDelete>
                                                </Button>
                                            </Flex>
                                        </Td>}
                                        {job?.jobStatus === JobStatus.Completed && <Td><Text >{item.reason || "N/A"}</Text></Td>}
                                        {job?.jobStatus === JobStatus.Completed && <Td><Text >{item.whatsappMsgId || "N/A"}</Text></Td>}
                                        {!!(selectedTemplate?.TEMPLATE_HEADER_TYPE ||
                                            selectedTemplate?.TEMPLATE_VARS?.length ||
                                            selectedTemplate?.BUTTON_VARS?.length) && (
                                                <Td>
                                                    {item.dynamicValues && Object.keys(item.dynamicValues).length > 0 ? (
                                                        Object.entries(item.dynamicValues).map(([key, value], ind) => (
                                                            <Text key={key}>
                                                                <strong>{`${ind + 1}. ${key}`}</strong>: {value}
                                                            </Text>
                                                        ))
                                                    ) : (
                                                        "NO DATA"
                                                    )}
                                                </Td>
                                            )}

                                    </Tr>
                                )
                            })
                        }
                    </Tbody>
                </Table>

                {benFilter && <BenFilterPopup handleCloseModal={() => handleCloseModal(setBenFilter, benFilter)}></BenFilterPopup>}
            </Box>

        </Layout >
    )
}